<script>
  const layouts = {
    input(h, data) {
      return (
        <el-form-item label={data.name} label-width="80px">
          <el-input
            value={data.options.defaultValue}
            on-input={(value) => (data.options.defaultValue = value)}
            placeholder={data.options.placeholder}
            style={{ width: data.options.width }}
          ></el-input>
        </el-form-item>
        //       <span class="drawing-item-delete" >
        // <i class="el-icon-close" /></span>
      )
    },
    textarea(h) {
      return <el-button type="primary">主要按钮</el-button>
    },
  }
  export default {
    /* eslint-disable */
    props: ['item'],
    data() {
      return {}
    },
    methods: {},
    render(h) {
      let layout = layouts[this.item.type]
      return layout.call(this, h, this.item)
    },
  }
</script>
